module.exports = __webpack_public_path__ + "static/media/thumb-up-svgrepo-com (4).66ef9c62.svg";